var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 79.8 78.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:#84aff1;}.cls-5{fill:#3865ab;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 6.25,
    x2: 23.93,
    y2: 6.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2cc0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 55.87,
    y1: 6.25,
    x2: 79.8,
    y2: 6.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 27.93,
    y1: 6.25,
    x2: 51.87,
    y2: 6.25,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,1V12.49H23.93V0H1A1,1,0,0,0,0,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.87,12.49H79.8V1a1,1,0,0,0-1-1H55.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 27.93,
    width: 23.93,
    height: 12.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 27.93,
    y: 16.49,
    width: 23.93,
    height: 12.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 16.49,
    width: 23.93,
    height: 12.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 55.87,
    y: 16.49,
    width: 23.93,
    height: 12.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 55.87,
    y: 32.99,
    width: 23.93,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 27.93,
    y: 32.99,
    width: 23.93,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 32.99,
    width: 23.93,
    height: 12.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 27.93,
    y: 49.48,
    width: 23.93,
    height: 12.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 55.87,
    y: 49.48,
    width: 23.93,
    height: 12.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 49.48,
    width: 23.93,
    height: 12.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 27.93,
    y: 65.98,
    width: 23.93,
    height: 12.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M79.8,77.47V66H55.87V78.47H78.8A1,1,0,0,0,79.8,77.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M23.93,78.47V66H0V77.47a1,1,0,0,0,1,1Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTable);
export default __webpack_public_path__ + "static/media/icn-table.3ee1d0cca4b9aeec9ea547f8407bef0a.svg";
export { ForwardRef as ReactComponent };